export const getLinks = (isLoggedIn) => [
  isLoggedIn ? ['', 'LogOut'] : ['/provider', 'For healthcare professionals', true],
  ['/news', 'news'],
  ['/faq', 'FAQ'],
  ['/contact', 'Contact'],
];
